import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { environment } from 'src/environments/environment';
import { GitihService } from 'src/app/gitih/services/gitih.service';
import packageJson from '../../../../package.json';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  titol = "";
  ajuda = "";
  suport = "";
  urlAPI = "";
  production = environment.production;
  navBarColor = environment['navBarColor'];

  logServidorBd = environment['logServidorBd'];
  logICAMBd = environment['logICAMBd'];

  versioClient:string = packageJson.version;
  versioServer:string = '';
  cookieAct = 'gitih.act';
  ara = new Date();
  ultimAct = new Date();
  versioIgual = false;

  constructor(
    public auth: AuthService,
    private gitihService: GitihService) { }

  ngOnInit() {
    if (!this.navBarColor) {
      this.navBarColor = '#17a2b8';
    }
    console.log(this.navBarColor);
    this.titol = environment.titol;
    this.ajuda = environment.ajuda;
    this.suport = environment.suport;
    this.urlAPI = environment.urlAPI;

    this.ultimAct = new Date(this.gitihService.getCookie(this.cookieAct));
    console.log(this.ultimAct);

    this.gitihService.getVersion()
    .subscribe( (resp:any) => {
      console.log(resp);
      this.versioServer = resp.version;
      this.versioIgual = this.versioServer == this.versioClient;
      if (!this.versioIgual && (!this.ultimAct || this.ultimAct.getDate() != this.ara.getDate())) {
        console.log("refresh");
        this.gitihService.setCookie(this.cookieAct,this.ara.toISOString(),100);
        window.location.reload();
      }
    })
  }

  opcionsPerfil() {
    return this.auth.perfilAutoritzat('historic') || 
           this.auth.perfilAutoritzat('activitat') || 
           this.auth.perfilAutoritzat('logs') ||
           this.auth.perfilAutoritzat('logs-icam') ||
           this.auth.perfilAutoritzat('diag-no-icam');
  }
}
